import React from "react";

export default class StepOptionSelection extends React.Component {
    render() {
        return <div className={"step_selection_wrapper"} onClick={this.props.onClick}>
            <div className={"step_selection " + this.props.className}>
                {this.props.children}
            </div>
        </div>
    }
}